<div mat-dialog-title class="dialog-header aum-typo-headline-3">
    <div class="dialog-title">
        <span class="title-span"> {{ 'aumico_reports_valuation_report_announcement_dialog_title' | i18next }}</span>
    </div>
    <div class="seprator"></div>
    <div class="close-dialog">
        <mat-dialog-actions>
            <mat-icon (click)="closeDialog()" svgIcon="interface-delete 1"></mat-icon>
        </mat-dialog-actions>
    </div>
</div>
<div mat-dialog-content>
    <div>
        <span>
            {{ 'aumico_reports_valuation_report_announcement_dialog_content_1' | i18next }}
        </span>
        <br />
        <br />
        <span>
            {{ 'aumico_reports_valuation_report_announcement_dialog_content_2' | i18next }}
        </span>
        <br />
        <br />
        <span>
            {{ 'aumico_reports_valuation_report_announcement_dialog_content_3' | i18next }}
        </span>
    </div>

    <span class="valuation-report-image">
        <img src="assets/valuation-report.svg" />
    </span>
</div>
<div class="actions-footer">
    <mat-dialog-actions>
        <button aum-button (click)="onTryItOutClick()" color="blue">
            {{ 'aumico_reports_valuation_report_announcement_dialog_button_text' | i18next }}
        </button>
    </mat-dialog-actions>
</div>
